import React, { useEffect, useState } from "react";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";
import { useDialog } from "../../../../contexts/DialogContext";
import SaveIcon from "@mui/icons-material/Save";

import { Grid, DialogActions, Button, CircularProgress } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import usePlan from "../../../../hooks/usePlan";

function DeletePlanModal(props) {
  const { planId, refreshPage } = props;

  const { deletePlan, isLoading } = usePlan();
  const dispatch = useDispatch();
  const { unSetDialog } = useDialog();

  const methods = useForm();

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;

  const onSubmit = async () => {
    try {
      await deletePlan(planId);
      dispatch(showSuccessSnackbar("Plan deleted successfully!"));
      refreshPage();
      unSetDialog("delete_plan");
    } catch (err) {
      const errMsg = err?.response?.data?.message || err?.message || "Failed to delete plan";
      dispatch(showErrorSnackbar(errMsg));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <i>Do you want to delete this ?</i>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              endIcon={isLoading ? <CircularProgress size={24} /> : null}
              disabled={isLoading}
            >
              Yes
            </Button>

            <Button variant="text" onClick={() => unSetDialog("delete_plan")} color="primary">
              No
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default DeletePlanModal;
